import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ContactForm } from "./ContactForm";

/**
 * Anfrage-Drawer: Öffnet das Anfrage-Formular als Overlay direkt dort, wo der
 * Nutzer gerade ist — statt die gesamte Seite bis zum Kontakt-Bereich
 * durchzuscrollen. Wird über `openContact(serviceKey?)` geöffnet.
 */
export const openContact = (serviceKey) => {
  window.dispatchEvent(new CustomEvent("jh:open-contact", { detail: serviceKey || null }));
};

export const ContactDrawer = () => {
  const [open, setOpen] = useState(false);
  const [service, setService] = useState(null);

  useEffect(() => {
    const onOpen = (e) => {
      setService(e.detail || null);
      setOpen(true);
    };
    window.addEventListener("jh:open-contact", onOpen);
    return () => window.removeEventListener("jh:open-contact", onOpen);
  }, []);

  // Lenis pausieren, solange das Overlay offen ist (kein Scrollen der Seite dahinter)
  useEffect(() => {
    const lenis = window.__lenis;
    if (!lenis) return;
    if (open) lenis.stop();
    else lenis.start();
    return () => lenis.start();
  }, [open]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        side="right"
        data-lenis-prevent
        data-testid="contact-drawer"
        className="w-full sm:max-w-xl overflow-y-auto bg-paper text-ink border-l border-black/10 p-0"
      >
        <SheetHeader className="px-8 pt-10 pb-2 text-left">
          <p className="text-xs uppercase tracking-[0.35em] text-zinc-500">Projekt starten</p>
          <SheetTitle className="font-display uppercase tracking-tight leading-[0.95] text-3xl sm:text-4xl">
            Du hast eine Idee?{" "}
            <span className="font-editorial italic normal-case tracking-normal text-gold">Lass uns reden.</span>
          </SheetTitle>
          <SheetDescription className="text-sm text-zinc-500">
            Schreib mir kurz, worum es geht — ich melde mich schnell zurück.
          </SheetDescription>
        </SheetHeader>
        <ContactForm
          idPrefix="dcf"
          testPrefix="drawer-contact"
          presetService={service}
          className="px-8 pb-10 pt-4"
        />
      </SheetContent>
    </Sheet>
  );
};
